import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { getDocumentProcessStatusAsync } from '../proposal/proposalThunk';
import { getClausesAsync, sendMessageAsync } from '../chat/chatThunk';
export const loadingSlice = createSlice({
    name: 'app/loading',
    initialState: {
        pendingRequestCount: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(isPending, (state, action) => {
            if (action.type === getDocumentProcessStatusAsync.pending.type &&
                action.meta.arg?.background === true) {
                return;
            }
            if (action.type === getClausesAsync.pending.type &&
                action.meta.arg?.background === true) {
                return;
            }
            if (action.type === sendMessageAsync.pending.type) {
                return;
            }
            state.pendingRequestCount += 1;
        });
        builder.addMatcher(isFulfilled, (state) => {
            state.pendingRequestCount = Math.max(state.pendingRequestCount - 1, 0);
        });
        builder.addMatcher(isRejected, (state) => {
            state.pendingRequestCount = Math.max(state.pendingRequestCount - 1, 0);
        });
    }
});
export default loadingSlice.reducer;
